import { getSeparatedValue } from '../../../utils/objects-util';
import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import SideMenu from '../SideMenu';
import IconButton from '../IconButton';
import './style.scss';
import MenuService from '../../../services/menu';
import { getHistoryLocationParams } from '../../../utils/routesHelper';
import { useDispatch } from 'react-redux';
import { createAction } from '../../../utils/sagaHelper';
import {ORDERING_MENU_TYPE_SECTION_MODEL} from "../../../utils/enums.js";

const SideMenuItem = ({ menuItem, groupSections, rootState, getModel, clickedNested, clickedSpoiler, checkForUpdate }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();
    const history = useHistory();

    const checkIsOpen = !!location.pathname.includes(menuItem.pathname) || !!location.pathname.includes(ORDERING_MENU_TYPE_SECTION_MODEL.orderingMenu.toLowerCase())
    const [isOpen, setIsOpen] = useState(checkIsOpen)

    const [menu, setMenu] = useState(null);

    useLayoutEffect(() => {
        if (menuItem.nestedMenuType) {
            const newMenu = MenuService.instance.getMenu(menuItem.nestedMenuType);
            setMenu(newMenu);
        }
    }, [isOpen, menuItem.nestedMenuType]);

    useEffect(() => {
        if (menuItem.nestedMenuType && menuItem.actionLoad && !checkForUpdate) {
            dispatch(createAction(menuItem.actionLoad));
        }
        // eslint-disable-next-line
    }, []);

    const handleOnItemAction = () => {
        if(menuItem.disable) {
            return;
        }
        if (menuItem.nestedMenuType) {
            return setIsOpen(!isOpen)
        }

        if (clickedSpoiler) {
            const id = menuItem?.searchParams?.(rootState)
            if(typeof id === 'string') {
                const rootId = id.replace('?id=', '');
                let businessId = rootState.restaurant.data.businessMenu?.id || '';
                businessId = rootId === businessId ? '' : `&businessId=${businessId}`;
                history.push(menuItem.pathname + (menuItem.searchParams && menuItem.searchParams(rootState) + businessId));
                return;
            }
            history.push(menuItem.pathname)
            return
        }

        if (clickedNested) {
            const model = getModel(menuItem.pathname);

            if (model) {
                const parentModel = getModel(model.model ? model.model.parentUrl : model.parentUrl || '');
                if (parentModel && parentModel.id) {
                    history.push(menuItem.pathname + '?id=' + parentModel.id);
                } else {
                    const { parentId, id } = getHistoryLocationParams(window.location.search);
                    history.push(
                        menuItem.pathname +
                            ((menuItem.searchParams && menuItem.searchParams(rootState)) || '?id=' + (parentId || id))
                    );
                }
            } else {
                history.push(menuItem.pathname + location.search);
            }

            return;
        }

        const type = menuItem.pathname;
        const groupSection = getSeparatedValue(type, '/', 4).split('?')[0];

        history.push(
            (groupSections[groupSection] || '').split('?id=')[0] === location.pathname
                ? type
                : groupSections[groupSection] || type
        );
    };

    return (
        <>
            <li
                key={`sideMenuItem-${menuItem.title}`}
                className={classNames('sideMenuItem', {
                    active: menuItem.active(location),
                    useSeparator: menuItem.useSeparator,
                    withSpoiler: !!menuItem.nestedMenuType,
                    disable: menuItem.disable
                })}
                data-tip={t(menuItem.title)}
                onClick={handleOnItemAction}
            >
                <div className={'placeIcon'}>
                    {!!menuItem.icon && (
                        <div className={classNames('icon', menuItem.icon)} />
                    )}
                    {menuItem.isWithIcon && menuItem.isWithIcon(rootState)}
                </div>
                <div className={classNames('menuItem', {noIcon: !menuItem.icon})}>
                    <p className={classNames('menuItemContent')}>{t(menuItem.title)}</p>
                    {menuItem.titleInfo && (!menuItem.isTitleInfoShow || menuItem.isTitleInfoShow()) && (
                        <div className={classNames('titleInfo')}>{t(menuItem.titleInfo)}</div>
                    )}
                    {!!menuItem.nestedMenuType && (
                        <IconButton isIcon iconName={classNames('angleUp', { isOpen: isOpen })} />
                    )}
                </div>
            </li>

            {menu && isOpen && (
                <div className={'spoiledList'}>
                    <SideMenu menu={menu} clickedSpoiler={true} />
                </div>
            )}
        </>
    );
};

export default SideMenuItem;
